import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';
import { getSurfaceColor, getThemeTokens, radii } from '../tokens';

export const styledMuiMenuItem = (
  theme: Theme,
): BackstageOverrides['MuiMenuItem'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      borderRadius: radii.md,
      color: tokens.textPrimary,
      margin: theme.spacing(0.5),
      minHeight: theme.spacing(5),
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      position: 'relative',
      '@media (min-width: 600px)': {
        minHeight: theme.spacing(5),
      },
      '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
        '&::before': {
          backgroundColor: theme.palette.primary.main,
          borderRadius: 999,
          bottom: theme.spacing(1),
          content: '""',
          left: theme.spacing(0.5),
          position: 'absolute',
          top: theme.spacing(1),
          width: 3,
        },
      },
      '&.Mui-selected:hover, &:hover': {
        backgroundColor: getSurfaceColor(theme, 'accent'),
      },
    },
  };
};
